import { render } from "./MarkedFilesReportsList.vue?vue&type=template&id=28b49f6a&scoped=true"
import script from "./MarkedFilesReportsList.vue?vue&type=script&lang=js"
export * from "./MarkedFilesReportsList.vue?vue&type=script&lang=js"

import "./MarkedFilesReportsList.vue?vue&type=style&index=0&id=28b49f6a&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b49f6a"]])

export default __exports__